/* mc-cart-count.js — keeps "Narudžba (n)" honest without a reload.

   Handover „Header naslovne" §8: the counter has to change without the
   page refreshing. Liquid renders the correct number on first paint, so
   this file only has to catch what happens after that — and if it never
   loads, the header still shows a real number rather than a zero.

   The drawer mutates the cart through /cart/add.js and /cart/change.js
   and then re-renders itself; it does not know a counter exists. Rather
   than teach every call site, this listens once for the response.

   Cheap: one HEAD-weight JSON read, only after a cart write, and only
   when a counter is actually on the page. */
(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-mc-cart-count]');
  if (!nodes.length) return;

  var pending = false;

  function paint(n) {
    nodes.forEach(function (el) { el.textContent = String(n); });
    var link = document.querySelector('[data-mc-cart-link]');
    if (link) link.setAttribute('data-count', String(n));
  }

  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count); })
      .catch(function () { /* leave the server-rendered number alone */ })
      .finally(function () { pending = false; });
  }

  /* Published so anything in the theme can say "the cart moved" without
     importing this file or knowing how the counter is drawn. */
  window.mcRefreshCart = refresh;
  document.addEventListener('mc:cart', refresh);

  /* The general case: wrap fetch and react to any successful write to a
     /cart/ endpoint. This is the only way to cover code that already
     exists — mc-drawer.js, bh-cod-form.js and anything added later — with
     no edit to any of them.

     Deliberately narrow: it inspects the URL, never the body, changes no
     request, swallows nothing, and returns the original promise
     untouched. A failure here cannot break a cart write. */
  if (window.fetch) {
    var real = window.fetch;
    window.fetch = function (input, init) {
      var out = real.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/') !== -1) {
          out.then(function (r) { if (r && r.ok) refresh(); }).catch(function () {});
        }
      } catch (e) { /* never let bookkeeping break the request */ }
      return out;
    };
  }

  /* Back/forward cache serves the page with a stale counter. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
